module.exports = __webpack_public_path__ + "static/img/icon_footer_wechatmini_ev.1973d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_footer_wechatmini_ev.png
// module id = Acv3
// module chunks = 1 5